import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'
import {isLangEN} from '_metronic/helpers/GeneralHelper'

export function SystemMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/system-mgt/'

  const menuPlacement = isLangEN() ? 'bottom-start' : 'bottom-end'

  return (
    <>
      {/* USERS */}
      {hasPermission('user-list') && (
        <MenuInnerWithSub
          title={t('MENU.USERS')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('user-list') && (
            <MenuItem to={`${base}users`} fontIcon='fas fa-users' title={t('MENU.USERS')} />
          )}

          {hasPermission('role-list') && (
            <MenuItem to={`${base}roles`} fontIcon='fas fa-user-shield' title={t('MENU.ROLES')} />
          )}
        </MenuInnerWithSub>
      )}

      {/* CAMPUSES */}
      {hasPermission('campus-list') && (
        <MenuInnerWithSub
          title={t('MENU.CAMPUSES')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('campus-list') && (
            <MenuItem
              to={`${base}campuses`}
              fontIcon='fas fa-university'
              title={t('MENU.CAMPUSES')}
            />
          )}

          {hasPermission('campus-unit-list') && (
            <MenuItem
              to={`${base}campus-units`}
              fontIcon='fas fa-landmark'
              title={t('MENU.CAMPUS_UNITS')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* FACULTIES */}
      {hasPermission('faculty-list') && (
        <MenuInnerWithSub
          title={t('MENU.FACULTIES')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('faculty-list') && (
            <MenuItem
              to={`${base}faculties`}
              fontIcon='fas fa-chalkboard-teacher'
              title={t('MENU.FACULTIES')}
            />
          )}

          {hasPermission('campus-unit-faculty-list') && (
            <MenuItem
              to={`${base}cu-faculties`}
              fontIcon='fas fa-building'
              title={t('MENU.CAMPUS_UNIT_FACULTIES')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* GRADING */}
      {hasPermission('grading-score-list') && (
        <MenuItem title={t('LABEL.GRADING_SYSTEM')} to={`${base}grading`} />
      )}

      {/* SESSION */}
      {hasPermission('lesson-session-details-list') && (
        <MenuItem title={t('LABEL.SESSION')} to={`${base}lesson-session-details`} />
      )}

      {/* SCHOOL */}
      <MenuInnerWithSub
        title={t('MENU.SCHOOL')}
        to=''
        menuPlacement={menuPlacement}
        menuTrigger='click'
        hasArrow={false}
      >
        <MenuItem
          to={`${base}admission-fee`}
          fontIcon='fas fa-usd'
          title={t('LABEL.ADMISSION_FEE')}
        />
        {hasPermission('school-subject-list') && (
          <>
            <MenuItem
              to={`${base}school-academic-tools`}
              fontIcon='fas fa-layer-group'
              title={t('MENU.ACADEMIC_TOOLS')}
            />
            <MenuItem to={`${base}subjects`} fontIcon='fas fa-book' title={t('MENU.SUBJECTS')} />
            <MenuItem
              to={`${base}class-subjects`}
              fontIcon='fas fa-layer-group'
              title={t('MENU.ASSIGN_CLASS_SUBJECTS')}
            />
          </>
        )}

        {hasPermission('campus-class-list') && (
          <MenuItem to={`${base}classes`} fontIcon='fas fa-chalkboard' title={t('MENU.CLASSES')} />
        )}

        {hasPermission('school-book-list') && (
          <>
            <MenuItem to={`${base}books`} fontIcon='fas fa-book-open' title={t('MENU.BOOKS')} />
            <MenuItem
              to={`${base}class-books`}
              fontIcon='fas fa-book-open'
              title={t('MENU.ASSIGN_CLASS_BOOKS')}
            />
          </>
        )}

        {hasPermission('school-uniform-list') && (
          <>
            <MenuItem to={`${base}uniforms`} fontIcon='fas fa-tshirt' title={t('MENU.UNIFORMS')} />
            <MenuItem
              to={`${base}class-uniforms`}
              fontIcon='fas fa-tshirt'
              title={t('MENU.ASSIGN_CLASS_UNIFORMS')}
            />
          </>
        )}

        {hasPermission('school-transport-list') && (
          <MenuItem to={`${base}transports`} fontIcon='fas fa-bus' title={t('MENU.TRANSPORTS')} />
        )}
      </MenuInnerWithSub>

      {/* TOOLS */}
      {hasPermission('relative-list') && (
        <MenuInnerWithSub
          title={t('MENU.TOOLS')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          <MenuItem
            to={`${base}relatives`}
            fontIcon='fas fa-user-friends'
            title={t('MENU.RELATIVES')}
          />
          <MenuItem
            to={`${base}card-design`}
            fontIcon='fas fa-id-card'
            title={t('MENU.CARD_DESIGN')}
          />
        </MenuInnerWithSub>
      )}
    </>
  )
}
